import { Button } from '@/components/ui/button'
import { MessageCircle } from 'lucide-react'

const WhatsAppCTABanner = () => {
  const whatsappNumber = '554137950568'
  const message = 'Olá! Gostaria de mais informações sobre os fotolivros.'

  return (
    <div className="bg-card border border-border/50 rounded-2xl p-6 md:p-8 my-12 shadow-sm">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-start gap-4 flex-1">
          <div className="p-3 rounded-full bg-[#25D366]/15 border border-[#25D366]/20">
            <MessageCircle className="h-5 w-5 text-[#25D366]" />
          </div>
          <div>
            <h3 className="font-serif text-xl md:text-2xl font-semibold mb-2 text-foreground tracking-tight">
              Vamos conversar?
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Nossa equipe está aqui para orientar você em cada etapa. Fale
              conosco pelo WhatsApp e descubra como criar o álbum perfeito para
              sua história.
            </p>
          </div>
        </div>
        <Button
          size="default"
          asChild
          className="gap-2 whitespace-nowrap bg-[#25D366] hover:bg-[#128C7E] text-foreground hover:text-white font-medium"
        >
          <a
            href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MessageCircle className="h-4 w-4" />
            Chamar no WhatsApp
          </a>
        </Button>
      </div>
    </div>
  )
}

export default WhatsAppCTABanner
